function decodeMinewQrCodeString (qrCodeString) {
  const formattedQrCodeString = formatAlternateIdKey(qrCodeString)

  if (formattedQrCodeString.length === 12 &&
    /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{8}/.test(formattedQrCodeString)) {
    return formattedQrCodeString
  }

  return ''
}

function decodeKkmQrCodeString (qrCodeString) {
  if (qrCodeString.length >= 12 && qrCodeString.length < 32 &&
    /^MAC:[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{8},SERIAL.+/.test(qrCodeString)) {
    return qrCodeString.split(':')[1].split(',')[0]
  }

  return ''
}

function decodeHoneyCommQrCodeString (qrCodeString) {
  const formattedQrCodeString = formatAlternateIdKey(qrCodeString)

  if (formattedQrCodeString.length === 12 &&
    /^[a-zA-Z]{1}[a-zA-Z0-9]+$/u.test(formattedQrCodeString)) {
    return formattedQrCodeString
  }

  return ''
}

function decodeRfidQrCodeString (qrCodeString) {
  if (!qrCodeString || typeof qrCodeString !== 'string') {
    return ''
  }

  const normalized = formatAlternateIdKey(qrCodeString)

  // EPC is hex, typically even-length bytes. Keep this lenient but bounded.
  if (normalized.length < 8 || normalized.length > 32) {
    return ''
  }

  if (normalized.length % 2 !== 0) {
    return ''
  }

  if (!/^[0-9A-F]+$/u.test(normalized)) {
    return ''
  }

  return normalized
}

function formatAlternateIdKey (address) {
  return address.replace(/:/ug, '').replace(/-/ug, '').toUpperCase()
}

function isBleAlternateIdKey (key) {
  return decodeHoneyCommQrCodeString(key) ||
    decodeMinewQrCodeString(key) ||
    decodeKkmQrCodeString(key)
}

module.exports = {
  decodeMinewQrCodeString,
  decodeKkmQrCodeString,
  decodeHoneyCommQrCodeString,
  decodeRfidQrCodeString,
  formatAlternateIdKey,
  isBleAlternateIdKey
}
